export default "__VITE_ASSET__D2mHsse6__"